import {
    ChangeDetectionStrategy,
    Component,
    computed,
    Inject,
    Input,
    Signal,
} from "@angular/core";

import { toSignal } from "@angular/core/rxjs-interop";

import { TabChangeEvent } from "@hermes/aphrodite/tab";
import { Context, LOCALE } from "@hermes/app-core";
import { isChina, Locale } from "@hermes/locale";
import {
    ShopLocatorFacade,
    ShopLocatorMode,
} from "@hermes/states/shop-locator";
import { BreakpointService } from "@hermes/utils-generic/services/user-interface";

@Component({
    selector: "h-shop-locator-search",
    templateUrl: "./shop-locator-search.component.html",
    styleUrls: ["./shop-locator-search.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ShopLocatorSearchComponent {
    /** FIXME: will be removed with APLBLG-177166 */
    @Input()
    public shouldDisplayMapTabs: boolean = true;

    public shouldDisplayTabs = computed(
        () =>
            !this.isChina && this.isMobile() && this.context.isInBrowserMode(),
    );

    public readonly isMapMobile: Signal<boolean> = computed(
        () => this.shopLocatorMode() === ShopLocatorMode.MapMobile,
    );

    private isMobile: Signal<boolean>;

    private isChina = isChina(this.locale);

    private readonly shopLocatorMode: Signal<ShopLocatorMode | undefined> =
        toSignal(this.shopLocatorFacade.mode$);

    constructor(
        private breakpointService: BreakpointService,
        private shopLocatorFacade: ShopLocatorFacade,
        private context: Context,
        @Inject(LOCALE) private locale: Locale,
    ) {
        this.isMobile = this.breakpointService.isMobile;
    }

    public setSelected(event: TabChangeEvent): void {
        this.shopLocatorFacade.setMode(
            event.index === 1
                ? ShopLocatorMode.MapMobile
                : ShopLocatorMode.NoMap,
        );
    }
}
